<article class="company-card">
  <header class="company-card__header">
    <app-user-avatar [name]="row.companyName" [size]="'small'"></app-user-avatar>
    <div class="company-card__identity">
      <h3 class="company-card__name">{{ row.companyName }}</h3>
      <p class="company-card__cnpj">CNPJ {{ row.cnpj | mask: '99.999.999/9999-99' }}</p>
    </div>
  </header>

  <div class="company-card__pending">
    <div class="company-card__pending__text">
      <span class="company-card__pending__label">PENDENTES DE ANÁLISE</span>
      <span class="company-card__pending__hint">
        {{ row.pendingDocuments }} {{ pendingLabel }}
      </span>
    </div>
    <strong class="company-card__pending__value">{{ row.pendingDocuments }}</strong>
  </div>

  <div class="company-card__stats">
    <div class="company-card__stat">
      <span class="company-card__stat__label">APROVADOS</span>
      <strong class="company-card__stat__value">{{ row.approvedDocuments }}</strong>
    </div>
    <div class="company-card__stat">
      <span class="company-card__stat__label">REJEITADOS</span>
      <strong
        class="company-card__stat__value"
        [class.company-card__stat__value--rejected]="row.rejectedDocuments > 0">
        {{ row.rejectedDocuments }}
      </strong>
    </div>
    <div class="company-card__stat">
      <span class="company-card__stat__label">TOTAL</span>
      <strong class="company-card__stat__value">{{ row.totalDocuments }}</strong>
    </div>
  </div>

  <app-document-analysis-composition-bar
    [pending]="row.pendingDocuments"
    [approved]="row.approvedDocuments"
    [rejected]="row.rejectedDocuments"></app-document-analysis-composition-bar>

  <app-button
    [id]="'analyze-' + row.id"
    [label]="'Analisar'"
    [type]="'button'"
    (sendButtonClick)="analyze.emit(row.id)"></app-button>
</article>
